"use client";

import {useState, useEffect} from "react";
import {redirect, RedirectType, usePathname} from "next/navigation";
import {getCookie} from "typescript-cookie";

export default function AuthProvider({children}: {children: React.ReactNode})
{
    const [authenticated, setAuthenticated] = useState(false);
    const pathname = usePathname();

    useEffect(() =>
    {
        if (authenticated || !pathname)
            return;

        if (getCookie("auth"))
            return setAuthenticated(true);

        sessionStorage.setItem("referrer", pathname);
        redirect("/auth", RedirectType.push);
    },
    [pathname]);

    return authenticated && children;
}
